import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { toBanglaNumber, formatCurrency } from '../../lib/utils';
import { KioskScreen } from '../../components/kiosk/KioskScreen';
export function PaymentProcessing() {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    quantity = 1,
    total = 20,
    gateway = 'bkash'
  } = location.state || {};
  useEffect(() => {
    const t = setTimeout(() => navigate('/success', {
      state: {
        quantity,
        total,
        gateway
      }
    }), 2500);
    return () => clearTimeout(t);
  }, [navigate, quantity, total, gateway]);
  const isBkash = gateway === 'bkash';
  const gColor = isBkash ? '#e2136e' : '#f7931e';
  const gName = isBkash ? 'বিকাশ' : 'নগদ';
  return <KioskScreen showFooter={false} data-id="element-539">
      <main className="flex-1 min-h-0 flex items-center justify-center px-6" data-id="element-540">
        <div className="w-full max-w-md bg-white/95 backdrop-blur-md rounded-3xl shadow-xl border border-white/80 p-8 text-center" data-id="element-541">
          <div className="relative w-20 h-20 mx-auto mb-5" data-id="element-542">
            <div className="absolute inset-0 rounded-full animate-ping opacity-20" style={{
            backgroundColor: gColor
          }} data-id="element-543" />
            <div className="w-20 h-20 rounded-full flex items-center justify-center relative z-10 shadow-xl" style={{
            backgroundColor: gColor
          }} data-id="element-544">
              <Loader2 className="w-9 h-9 text-white animate-spin" data-id="element-545" />
            </div>
          </div>

          <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mb-1" data-id="element-546">
            পেমেন্ট যাচাই করা হচ্ছে...
          </h2>
          <p className="text-slate-500 mb-5" data-id="element-547">অনুগ্রহ করে অপেক্ষা করুন</p>

          <div className="bg-slate-50 rounded-2xl p-4 border border-slate-100 grid grid-cols-3 gap-3 text-center" data-id="element-548">
            <div data-id="element-549">
              <p className="text-xs text-slate-500 mb-0.5" data-id="element-550">গেটওয়ে</p>
              <p className="text-sm font-bold" style={{
              color: gColor
            }} data-id="element-551">
                {gName}
              </p>
            </div>
            <div className="border-x border-slate-200" data-id="element-552">
              <p className="text-xs text-slate-500 mb-0.5" data-id="element-553">টিকিট</p>
              <p className="text-sm font-bold text-slate-900" data-id="element-554">
                {toBanglaNumber(quantity)} টি
              </p>
            </div>
            <div data-id="element-555">
              <p className="text-xs text-slate-500 mb-0.5" data-id="element-556">মোট</p>
              <p className="text-sm font-bold text-slate-900" data-id="element-557">
                {formatCurrency(total)}
              </p>
            </div>
          </div>
        </div>
      </main>
    </KioskScreen>;
}